import classNames from "classnames";
import React, { useState } from "react";

import MultiToggle, { Option } from "../../multi_toggle/multi_toggle";
import css from "./headline_tabs.scss";

type HeadlineTabsProps<ID_TYPE extends string> = {
  label: React.ReactNode | string;
  options: Option<ID_TYPE>[];
  onChange: (newValue: ID_TYPE) => void;
  value?: ID_TYPE;
  classes?: {
    label?: string;
  };
};

export const HeadlineTabs = <ID_TYPE extends string = string>({
  label,
  onChange,
  options,
  value,
  classes,
  children
}: React.PropsWithChildren<HeadlineTabsProps<ID_TYPE>>): JSX.Element => {
  const [selectedTab, setSelectedTab] = useState<ID_TYPE>(options[0].id);

  const handleTabChange = (newValue: ID_TYPE) => {
    if (!value) {
      setSelectedTab(newValue);
    }
    onChange(newValue);
  };

  return (
    <div className={css.container}>
      <div className={css.tabsOuter}>
        <div className={classNames(css.label_wrapper, classes?.label)}>{label}</div>
        <div className={css.content}>
          <MultiToggle<ID_TYPE>
            defaultSelected={value || selectedTab}
            options={options}
            onChange={handleTabChange}
          />
          {children}
        </div>
      </div>
    </div>
  );
};
